import InfiniteScroll from './src/index.mjs';

const _InfiniteScroll = InfiniteScroll;
_InfiniteScroll.install = (app) => {
  app.directive("InfiniteScroll", _InfiniteScroll);
};
const ElInfiniteScroll = _InfiniteScroll;

export { ElInfiniteScroll, _InfiniteScroll as default };
//# sourceMappingURL=index.mjs.map
